import React from "react";

export default function Builders() {
  const strengths = [
    {
      title: "Reliable schedule",
      copy: "Show-up-when-agreed is the baseline. Workdays confirmed in writing before mobilization, with clear communication if anything slips.",
    },
    {
      title: "Clean job sites",
      copy: "Site protected, debris managed daily, punch items closed before demob. Your homeowner or PM sees a professional finish, not a mess.",
    },
    {
      title: "Clear scope, no drama",
      copy: "Scope of work, materials list, and price agreed in writing before starting. Change orders discussed before they happen, not after.",
    },
    {
      title: "Direct owner communication",
      copy: "You talk to Jason, not a rotating crew lead. Quick answers by phone or email, and one point of accountability from bid to punch list.",
    },
  ];

  const capabilities = [
    "Punch-out & finish work on new builds",
    "Deck framing, decking, railings & steps",
    "Door & window installation packages",
    "Interior trim, casing, base & crown",
    "Fence installation & repairs",
    "Shed pads, small slabs & step pours",
    "Core drilling for MEP rough-ins",
    "Interior & exterior painting scopes",
  ];

  return (
    <section className="section builders" id="builders" aria-labelledby="builders-title">
      <div className="wrap">
        <div className="section-head">
          <div>
            <span className="eyebrow">For builders &amp; general contractors</span>
            <h2 id="builders-title">A dependable sub<br />for the work you need done well.</h2>
          </div>
          <p>Owner-operated LLC. Fully insured. Comfortable working alongside regional builders, custom-home GCs, and remodeling companies from southern Maine to the New Hampshire seacoast.</p>
        </div>

        <div className="insurance-callout" aria-label="Insurance and credentials">
          <div className="insurance-badge" aria-hidden="true">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M12 2 4 5v7c0 5 3.5 8.5 8 10 4.5-1.5 8-5 8-10V5l-8-3z" />
              <path d="m9 12 2 2 4-4" />
            </svg>
          </div>
          <div className="insurance-copy">
            <strong>Insured &amp; LLC-registered.</strong>
            <p>JKM Coastal Carpentry LLC carries <strong>$1,000,000 per occurrence / $2,000,000 aggregate</strong> commercial general liability through Spinnaker Insurance Company. Certificate of Insurance available on request &mdash; additional insured endorsements welcome for GC and property-owner contracts.</p>
          </div>
        </div>

        <div className="builders-grid">
          {strengths.map((s) => (
            <article className="builder-card" key={s.title}>
              <h3>{s.title}</h3>
              <p>{s.copy}</p>
            </article>
          ))}
        </div>

        <div className="builder-capabilities">
          <span className="eyebrow">Sub-contract scopes</span>
          <ul>
            {capabilities.map((c) => (
              <li key={c}>{c}</li>
            ))}
          </ul>
          <p className="builder-note">
            <strong>Full-house framing and new-home construction are not offered.</strong> Best fit as a trusted sub on defined scopes where quality and schedule matter.
          </p>
          <a className="btn" href="#contact">Request sub availability <span aria-hidden="true">&rarr;</span></a>
        </div>
      </div>
    </section>
  );
}
